import {Box} from '@material-ui/core'
import {DataGrid, GridColDef, GridRowsProp} from '@material-ui/data-grid'
import _ from 'lodash'
import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import {contentURL} from 'src/api/reactpt'
import ManagementTemplate from 'src/components/ManagementTemplate'
import Routine from 'src/models/Routine'
import {actions as routinesActions} from 'src/redux/modules/routines'
import {RootState} from 'src/redux/rootReducer'
import {Root, Thumbnail, ButtonSmall} from './styled'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const RoutinesPage: React.FC<RouteComponentProps> = ({history}: RouteComponentProps) => {
  const {routines, dataState} = useSelector((state: RootState) => state.routines)

  const dispatch = useDispatch()

  const onCreateRoutineClick = () => {
    history.push('/routines/create')
  }
  const onDeleteRoutineClick = (params: any) => {
    window.confirm('Are you sure you want to delete?')
    dispatch(routinesActions.deleteRoutine({routineId: params.id as string}))
  }

  // Define the columns.
  const columns: GridColDef[] = [
    {field: 'title', headerName: 'Name', align: 'center', headerAlign: 'center', width: 200},
    {
      field: 'imageUrl',
      headerName: 'Image',
      width: 200,
      renderCell: (params) => <Thumbnail variant="square" src={params.value as string} />,
    },
    {
      field: 'isPublished',
      headerName: 'Published?',
      align: 'center',
      headerAlign: 'center',
      width: 150,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" justifyContent="center" width="100%">
            {params.value && <CheckCircleIcon />}
          </Box>
        )
      },
    },
    {
      field: 'isFeatured',
      headerName: 'Featured?',
      align: 'center',
      headerAlign: 'center',
      width: 150,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" justifyContent="center" width="100%">
            {params.value && <CheckCircleIcon />}
          </Box>
        )
      },
    },
    {
      field: 'numActions',
      headerName: 'Actions',
      align: 'center',
      headerAlign: 'center',
      width: 180,
    },
    {
      field: 'editControl',
      headerName: ' ',
      align: 'center',
      headerAlign: 'center',
      width: 200,
      renderCell: (params) => (
        <>
          <ButtonSmall
            onClick={() => {
              history.push(`/routines/${params.id}`)
            }}>
            Edit
          </ButtonSmall>
          <ButtonSmall
            variant="contained"
            color="secondary"
            onClick={() => onDeleteRoutineClick(params)}>
            Delete
          </ButtonSmall>
        </>
      ),
    },
  ]

  // Now the rows (the routine data)
  const values = _.values(routines) as Routine[]
  const rows: GridRowsProp = values.map(
    ({id, title, isFeatured, isPublished, actions, imageContentName}) => ({
      id,
      title,
      imageUrl: contentURL(imageContentName),
      isFeatured,
      isPublished,
      numActions: actions.length,
    }),
  )

  // Was there an error?
  const errorMessage = dataState.error ? dataState.error.message : undefined

  if (dataState.state === 'unloaded' && !errorMessage) {
    // Load up the users!
    dispatch(routinesActions.getRoutines())
  }

  return (
    <Root>
      <ManagementTemplate
        title="Manage Routines"
        busy={dataState.state === 'loading'}
        error={dataState.error}
        createButtonTitle="Create Routine"
        onCreateClick={() => onCreateRoutineClick()}>
        <DataGrid
          disableSelectionOnClick
          rowHeight={100}
          autoHeight
          rows={rows}
          columns={columns}
        />
      </ManagementTemplate>
    </Root>
  )
}

export default RoutinesPage
